export const isDirtyStateSelector = (state) => state.ui.autoSave.stateDirty;
export const isSavingStateSelector = (state) => state.ui.autoSave.saving;
export const hasErrorSelector = (state) => state.ui.autoSave.hasError;
